/**
 * Données structurées des pannes/réparations spécifiques (SEO longue traîne).
 *
 * Chaque panne a un contenu UNIQUE : symptômes, causes, solution technique,
 * tarif détaillé, délai, FAQ propre, conseils urgents.
 */
export const PANNES = [
  {
    slug: "ecran-casse-iphone-niort",
    titleH1: "Écran cassé iPhone à Niort - Remplacement en 30 min",
    metaTitle: "Écran cassé iPhone Niort - Remplacement Express dès 59 €",
    keyword: "écran cassé iPhone Niort",
    category: "iPhone",
    icon: "Smartphone",
    priceFrom: 59,
    priceTo: 179,
    durationMinutes: 30,
    durationLabel: "30 minutes",
    symptoms: [
      "Vitre fissurée ou éclatée",
      "Affichage noir ou strié",
      "Tactile qui ne répond plus",
      "Lignes verticales ou horizontales sur l'écran",
      "Taches noires (LCD endommagé)",
      "True Tone ne fonctionne plus après chute",
    ],
    causes: [
      "Chute sur sol dur (béton, carrelage)",
      "Choc thermique (passage chaud → froid)",
      "Pression excessive (poche serrée)",
      "Usure naturelle après plusieurs chutes",
    ],
    solution: "Démontage de l'iPhone, déconnexion de la batterie pour sécurité, retrait de l'écran endommagé, transfert du Face ID/Touch ID, pose du nouvel écran (origine Apple ou compatible premium selon budget), recalibrage du True Tone, contrôle qualité 4 points (tactile, luminosité, Face ID, son).",
    urgentTip: "🚨 N'utilisez pas votre iPhone si l'écran présente des éclats de verre — risque de blessure aux doigts. Couvrez l'écran de scotch transparent en attendant et apportez-le rapidement à Mediastore.",
    pricing: [
      { model: "iPhone 15 Pro Max", price: "179 €" },
      { model: "iPhone 15 / 15 Plus / 15 Pro", price: "179 €" },
      { model: "iPhone 14 / 14 Pro / Pro Max", price: "155 €" },
      { model: "iPhone 13 / 13 Pro / Pro Max", price: "129 €" },
      { model: "iPhone 12 / 12 Pro / Pro Max / mini", price: "109 €" },
      { model: "iPhone 11 / XR / XS", price: "95 €" },
      { model: "iPhone X", price: "95 €" },
      { model: "iPhone 8 / 8 Plus / SE 2-3", price: "69 €" },
      { model: "iPhone 7 / 6s / 6", price: "59 €" },
    ],
    faqs: [
      { q: "Mon iPhone fonctionne mais l'écran est fissuré, est-ce urgent de le remplacer ?", a: "Oui. Une fissure laisse passer poussières et humidité qui peuvent endommager les composants internes (caméra, capteur de proximité, écouteur). De plus, le tactile peut devenir aléatoire avec le temps. Faire intervenir Mediastore Niort sous 1 semaine évite des frais supplémentaires." },
      { q: "Le tactile ne répond plus après une chute, est-ce réparable ?", a: "Oui, dans la majorité des cas le LCD/OLED interne est cassé mais les autres composants restent intacts. Mediastore Niort diagnostique gratuitement et remplace uniquement l'écran si nécessaire. Tarif identique à un remplacement classique." },
      { q: "Quelle différence entre écran origine Apple et compatible premium ?", a: "Écran origine Apple : True Tone et Face ID parfaitement préservés, tarif +30% en moyenne. Compatible premium (Tianma, JDI) : qualité 95% identique, prix attractif, Face ID préservé. Mediastore propose les deux options avec devis transparent avant intervention." },
      { q: "Mediastore peut-il remplacer un écran iPhone le jour-même ?", a: "Oui, pour les modèles iPhone 8 à 15 Pro Max, écrans stockés en boutique. Intervention en 30 à 60 minutes sur place. Pour iPhone 6/6s/7 (modèles anciens), pièce commandée sous 24-48h." },
    ],
  },
  {
    slug: "batterie-iphone-niort",
    titleH1: "Changement batterie iPhone à Niort - Dès 49 €",
    metaTitle: "Batterie iPhone Niort - Remplacement Express dès 49 € | 6 mois garantie",
    keyword: "batterie iPhone Niort",
    category: "iPhone",
    icon: "Battery",
    priceFrom: 49,
    priceTo: 95,
    durationMinutes: 30,
    durationLabel: "20-30 minutes",
    symptoms: [
      "Autonomie qui chute brutalement (50% → 20% en quelques minutes)",
      "iPhone qui s'éteint à 30%, 40% ou même 60%",
      "Capacité maximale affichée < 80% (Réglages → Batterie)",
      "Téléphone très chaud lors d'usage normal",
      "Performances ralenties (limitation iOS)",
      "Iphone qui gonfle (DANGER - arrêt immédiat)",
    ],
    causes: [
      "Vieillissement naturel après 500+ cycles de charge",
      "Charge nocturne prolongée pendant des années",
      "Utilisation intensive (jeux, vidéo)",
      "Exposition à températures extrêmes",
      "Charge rapide quotidienne",
    ],
    solution: "Diagnostic santé batterie via outil pro, déconnexion sécurisée, retrait de l'ancienne batterie (gestion adhésif), pose batterie neuve haute capacité, calibrage initial (cycle 0-100% recommandé), test autonomie sous charge.",
    urgentTip: "⚠️ Si votre iPhone gonfle (écran qui se décolle, dos bombé), ÉTEIGNEZ-LE IMMÉDIATEMENT et ne le rechargez plus. Risque d'incendie. Apportez-le à Mediastore Niort en urgence.",
    pricing: [
      { model: "iPhone 15 Pro Max", price: "95 €" },
      { model: "iPhone 15 / 15 Pro / Plus", price: "95 €" },
      { model: "iPhone 14 / Pro / Pro Max", price: "85 €" },
      { model: "iPhone 13 / Pro / Pro Max / mini", price: "69 €" },
      { model: "iPhone 12 / 12 Pro / Pro Max / mini", price: "65 €" },
      { model: "iPhone 11 / XR / XS / X", price: "59 €" },
      { model: "iPhone 8 / 8 Plus / SE 2-3", price: "55 €" },
      { model: "iPhone 7 / 6s / 6", price: "49 €" },
    ],
    faqs: [
      { q: "Comment savoir si la batterie de mon iPhone doit être changée ?", a: "Allez dans Réglages > Batterie > État de la batterie. Si la 'Capacité maximale' est inférieure à 80%, Apple recommande le remplacement. Mediastore Niort effectue ce diagnostic gratuitement avec un outil professionnel plus précis qu'iOS." },
      { q: "Mediastore utilise-t-il des batteries d'origine Apple ?", a: "Nous proposons deux options : batteries compatibles haute capacité (qualité premium, +5 à +15% de capacité parfois) ou batteries origine Apple (selon disponibilité). Le devis est transparent et vous choisissez avant intervention. Toutes garanties 6 mois." },
      { q: "Combien de temps dure une batterie iPhone neuve ?", a: "Une batterie iPhone neuve dure typiquement 2 à 3 ans avec un usage normal (~500 cycles de charge). Pour maximiser sa durée : évitez la charge à 100% prolongée, ne descendez pas régulièrement sous 20%, évitez les températures extrêmes." },
      { q: "Le message 'Batterie d'origine inconnue' va-t-il apparaître après changement ?", a: "Avec une batterie compatible, oui — c'est une protection logicielle Apple (depuis iOS 13). Cela n'affecte PAS les performances ni l'autonomie. Avec une batterie origine Apple programmée via notre outil pro, ce message peut être évité (option +19 €)." },
    ],
  },
  {
    slug: "desoxydation-niort",
    titleH1: "Désoxydation Téléphone à Niort - iPhone, Samsung tombé dans l'eau",
    metaTitle: "Désoxydation iPhone, Samsung Niort - Téléphone Tombé dans l'Eau dès 69 €",
    keyword: "désoxydation téléphone Niort",
    category: "Urgence",
    icon: "Droplets",
    priceFrom: 69,
    priceTo: 179,
    durationMinutes: 2880,
    durationLabel: "24-48 heures",
    symptoms: [
      "Téléphone tombé dans l'eau (piscine, toilettes, lavabo)",
      "Pluie / éclaboussures",
      "Boisson renversée (café, soda, vin)",
      "Téléphone qui ne s'allume plus après contact eau",
      "Écran qui clignote ou affichage anormal",
      "Bouton accueil / volume bloqué",
      "Indicateur LCI (Liquid Contact Indicator) rouge",
    ],
    causes: [
      "Eau de mer/piscine (chlore + sel = corrosif)",
      "Boissons sucrées (sucre = court-circuit)",
      "Eau du robinet (calcaire + minéraux)",
      "Humidité prolongée (vapeur de douche)",
    ],
    solution: "⚡ Intervention URGENTE : démontage complet sous loupe binoculaire, retrait de la batterie immédiat (sécurité), bain ultrasonique dans solution isopropylique 99,9%, séchage contrôlé, nettoyage des connecteurs sous microscope, remontage avec joints d'étanchéité neufs si modèle compatible. Délai : 24 à 48h selon état.",
    urgentTip: "🚨 NE PAS faire : (1) Allumer ou recharger le téléphone (court-circuit garanti), (2) Plonger dans du riz (mythe, le riz absorbe lentement), (3) Sécher au sèche-cheveux (chaleur endommage les composants). À FAIRE : éteindre immédiatement, retirer la batterie si possible, sécher l'extérieur, apporter SANS DÉLAI à Mediastore Niort.",
    pricing: [
      { model: "iPhone / Samsung Galaxy S récent", price: "À partir de 119 €" },
      { model: "iPhone / Samsung milieu de gamme", price: "À partir de 95 €" },
      { model: "Smartphone entrée de gamme", price: "À partir de 69 €" },
      { model: "iPad / tablette", price: "À partir de 145 €" },
      { model: "MacBook (eau dans le clavier)", price: "À partir de 179 €" },
    ],
    faqs: [
      { q: "Quel est le délai maximum pour sauver un iPhone tombé dans l'eau ?", a: "Idéalement intervention dans les 24h. Plus l'intervention est tardive, plus la corrosion progresse et endommage de manière irréversible les composants. Taux de réussite : ~85% si intervention < 24h, ~50% si 24-72h, ~20% au-delà. Mediastore Niort propose des créneaux d'urgence." },
      { q: "Faut-il vraiment éviter le riz pour sécher un téléphone mouillé ?", a: "OUI. Le riz absorbe l'humidité de surface mais TRÈS LENTEMENT (24-48h) — pendant ce temps, la corrosion interne progresse. De plus, des grains de riz peuvent entrer dans les ports. La seule solution efficace est un démontage professionnel avec nettoyage isopropylique sous 24h." },
      { q: "Mon iPhone est étiqueté 'résistant à l'eau IP68', suis-je couvert par Apple ?", a: "NON. La garantie Apple EXCLUT les dégâts liquides (vérifiable via l'indicateur LCI rouge dans le port SIM). De plus, la résistance IP68 baisse avec le temps (joints qui s'usent). Mediastore Niort intervient sur tous les iPhone (y compris IP68) avec remplacement des joints si possible." },
      { q: "Peut-on récupérer les données d'un iPhone noyé qui ne s'allume plus ?", a: "Oui, dans la plupart des cas. Mediastore Niort effectue d'abord une réparation pour faire fonctionner le téléphone le temps de sauvegarder vos données (photos, contacts, messages). Si la carte mère est trop endommagée, récupération par transfert NAND (compétence spécialisée, sur devis)." },
    ],
  },
  {
    slug: "connecteur-charge-iphone-niort",
    titleH1: "Réparation Connecteur de Charge iPhone à Niort",
    metaTitle: "iPhone qui ne charge plus Niort - Réparation Connecteur Lightning / USB-C dès 55 €",
    keyword: "iPhone qui ne charge plus Niort",
    category: "iPhone",
    icon: "Usb",
    priceFrom: 55,
    priceTo: 119,
    durationMinutes: 45,
    durationLabel: "45-60 minutes",
    symptoms: [
      "Câble qui doit être incliné pour charger",
      "Charge qui s'arrête toute seule",
      "iPhone qui ne reconnaît plus le câble",
      "Charge très lente (>3h pour 100%)",
      "Connecteur visiblement endommagé ou plein de peluche",
      "Charge sans fil OK mais filaire HS (= connecteur)",
    ],
    causes: [
      "Peluches / poussières accumulées dans le port",
      "Câbles bon marché qui forcent le connecteur",
      "Chocs sur le câble branché",
      "Humidité résiduelle (oxydation)",
      "Usure naturelle après 4-5 ans",
    ],
    solution: "Nettoyage profond du port Lightning/USB-C sous microscope (parfois suffisant gratuitement !), test continuité, si défaillant : démontage iPhone, déconnexion batterie, remplacement de la nappe complète (Lightning ou USB-C selon modèle), test charge filaire + données + audio.",
    urgentTip: "💡 AVANT toute intervention payante : essayez de NETTOYER votre port. Éteignez l'iPhone, soufflez doucement (pas comprimé), et grattez très délicatement avec un cure-dent en bois (jamais métal). 1 iPhone sur 3 que nous voyons n'a pas besoin de réparation, juste de nettoyage. Mediastore propose ce nettoyage gratuitement.",
    pricing: [
      { model: "iPhone 15 / Pro / Pro Max (USB-C)", price: "119 €" },
      { model: "iPhone 14 / Pro / Pro Max (Lightning)", price: "109 €" },
      { model: "iPhone 13 / 12 / 11 (Lightning)", price: "85 €" },
      { model: "iPhone XS / XR / X / 8", price: "69 €" },
      { model: "iPhone 7 / 6s / 6 / SE", price: "55 €" },
      { model: "Samsung / Xiaomi / Huawei USB-C", price: "À partir de 69 €" },
    ],
    faqs: [
      { q: "Mon iPhone se charge en sans-fil mais pas en filaire, est-ce le connecteur ?", a: "Oui dans 95% des cas. Le connecteur Lightning/USB-C est défaillant ou encrassé. La charge sans-fil (MagSafe / Qi) utilise un circuit différent qui reste fonctionnel. Diagnostic gratuit à Mediastore Niort, nettoyage offert si c'est juste un encrassement." },
      { q: "Combien de temps dure un connecteur Lightning iPhone ?", a: "Typiquement 4 à 6 ans avec usage quotidien. Pour prolonger sa durée : nettoyez périodiquement (cure-dent bois, peluche), utilisez des câbles certifiés MFi Apple, évitez de tirer sur le câble pour débrancher. Mediastore propose un service de nettoyage préventif gratuit." },
      { q: "Remplacez-vous aussi le connecteur Samsung et USB-C Android ?", a: "Oui. Mediastore Niort remplace les connecteurs USB-C Samsung Galaxy (S/A/Note), Huawei (P/Mate/Nova), Xiaomi (Mi/Redmi/Poco), OnePlus, Google Pixel. Tarif à partir de 69 €. Pour les modèles récents (Z Fold/Flip), prix sur devis (complexité)." },
    ],
  },
  {
    slug: "face-id-iphone-niort",
    titleH1: "Réparation Face ID iPhone à Niort",
    metaTitle: "Face ID qui ne fonctionne plus Niort - Réparation iPhone Express",
    keyword: "Face ID iPhone Niort",
    category: "iPhone",
    icon: "ScanFace",
    priceFrom: 95,
    priceTo: 239,
    durationMinutes: 60,
    durationLabel: "1-2 heures",
    symptoms: [
      "Message 'Face ID non disponible'",
      "Configurez Face ID dans Réglages désactivé en grisé",
      "Reconnaissance qui marche par intermittence",
      "Face ID après réparation d'écran tiers",
      "Notch endommagée (chute, choc)",
    ],
    causes: [
      "Réparation d'écran chez non-spécialiste (Face ID transféré incorrectement)",
      "Chute ayant déconnecté le module dot projector",
      "Mise à jour iOS bugguée (rare, généralement résolu)",
      "Dégât liquide dans le module supérieur",
      "Modules d'origine non transférés lors de remplacement d'écran",
    ],
    solution: "Diagnostic poussé du module Face ID (dot projector, caméra infrarouge, illuminateur). Si écran récemment changé : transfert correct des modules d'origine. Si modules endommagés : remplacement de la nappe Face ID (pièce spécifique iPhone), reprogrammation sur outil professionnel Apple. Test complet en conditions diverses (lumière, obscurité, lunettes).",
    urgentTip: "⚠️ ATTENTION : si Face ID a cessé de fonctionner APRÈS une réparation d'écran ailleurs, le réparateur a probablement endommagé les modules. Apportez l'iPhone à Mediastore Niort — nous diagnostiquons gratuitement et indiquons si le module est récupérable.",
    pricing: [
      { model: "Réinitialisation Face ID (logiciel)", price: "95 €" },
      { model: "Remplacement nappe Face ID iPhone X/XS/XR", price: "145 €" },
      { model: "Remplacement nappe Face ID iPhone 11/12", price: "169 €" },
      { model: "Remplacement nappe Face ID iPhone 13/14/15", price: "205 €" },
      { model: "Réparation Dynamic Island (iPhone 14 Pro+)", price: "239 €" },
    ],
    faqs: [
      { q: "Pourquoi mon Face ID ne fonctionne plus depuis que j'ai changé l'écran ailleurs ?", a: "C'est très fréquent. Les modules Face ID sont SOUDÉS à l'écran d'origine et doivent être transférés EXACTEMENT au nouvel écran via une procédure technique précise. La plupart des réparateurs non-certifiés Apple ne maîtrisent pas cette procédure. Mediastore Niort, Apple-certifié, peut diagnostiquer et tenter une récupération si le module n'a pas été détruit." },
      { q: "Face ID peut-il être remplacé à 100% ?", a: "Réponse nuancée : oui techniquement, mais avec limitations. Apple verrouille certains composants au numéro de série de l'iPhone. Mediastore Niort peut remplacer le module physique, mais sur iPhone 12+ Apple peut afficher un message 'pièce non d'origine'. La fonction reste opérationnelle." },
      { q: "Mon Face ID ne fonctionne que la journée, pas le soir, pourquoi ?", a: "Probablement l'illuminateur infrarouge qui est défaillant. La journée, la lumière visible + caméra suffisent. Le soir, Face ID dépend uniquement de l'illuminateur IR. Mediastore Niort diagnostique gratuitement ce composant." },
    ],
  },
  {
    slug: "camera-iphone-niort",
    titleH1: "Réparation Caméra iPhone à Niort",
    metaTitle: "Caméra iPhone qui ne fonctionne plus Niort - Réparation dès 65 €",
    keyword: "caméra iPhone Niort",
    category: "iPhone",
    icon: "Camera",
    priceFrom: 65,
    priceTo: 239,
    durationMinutes: 60,
    durationLabel: "1 heure",
    symptoms: [
      "Photos floues ou troubles",
      "Caméra qui ne stabilise pas (auto-focus HS)",
      "Vibrations lors d'ouverture de l'app appareil photo",
      "Écran noir dans app appareil photo",
      "Lentille fissurée ou décollée",
      "Caméra avant (selfie) HS mais arrière OK",
      "Mode Portrait qui ne marche plus",
    ],
    causes: [
      "Chute ayant désaligné le module optique (OIS)",
      "Verre de protection cassé (lentille saphir)",
      "Capteur OIS bloqué",
      "Court-circuit (chute, eau)",
      "Câble flex de la caméra défaillant",
      "iOS bugué (rare)",
    ],
    solution: "Diagnostic du capteur de caméra (avant ou arrière), test de chaque mode (Photo, Vidéo, Portrait, Nuit). Démontage iPhone, déconnexion sécurisée, remplacement du module complet (caméra + lentille + capteur OIS), test stabilisation, comparaison qualité photo avant/après.",
    urgentTip: "💡 Avant intervention payante : redémarrez votre iPhone (maintien volume haut + power 10s), puis testez. Parfois c'est un bug logiciel résolu par un simple redémarrage. Si le problème persiste, Mediastore Niort effectue un diagnostic gratuit.",
    pricing: [
      { model: "Caméra arrière iPhone 15 Pro Max (triple)", price: "239 €" },
      { model: "Caméra arrière iPhone 14/15 Pro", price: "205 €" },
      { model: "Caméra arrière iPhone 13/14", price: "169 €" },
      { model: "Caméra arrière iPhone 11/12/XS", price: "129 €" },
      { model: "Caméra avant (FaceTime) - tous modèles", price: "À partir de 69 €" },
      { model: "Remplacement lentille saphir (verre seul)", price: "65 €" },
    ],
    faqs: [
      { q: "Ma caméra arrière vibre, est-ce dangereux ?", a: "Oui à terme. C'est le système OIS (stabilisation optique) qui est désynchronisé — souvent suite à une chute. Continuer à utiliser le téléphone peut endommager définitivement le module. Mediastore Niort intervient en 1h en boutique." },
      { q: "Si la vitre arrière de la caméra (lentille saphir) est cassée, faut-il changer toute la caméra ?", a: "Pas forcément. Si le capteur fonctionne bien et que seul le verre extérieur est fissuré, Mediastore Niort peut remplacer uniquement la lentille saphir (65 €). Si l'image est dégradée à cause du verre cassé, alors remplacement complet du module recommandé." },
      { q: "Le mode Portrait ne fonctionne plus, est-ce le LiDAR ?", a: "Sur iPhone 12 Pro et plus récents, oui. Le LiDAR est un capteur dédié à la profondeur (caméra arrière). S'il est défaillant, le mode Portrait avec arrière-plan flou est affecté. Mediastore Niort peut remplacer le module LiDAR séparément (sur devis)." },
    ],
  },
  {
    slug: "haut-parleur-iphone-niort",
    titleH1: "Réparation Haut-parleur iPhone à Niort - Son qui ne marche plus",
    metaTitle: "Haut-parleur iPhone Niort - Réparation Son dès 55 €",
    keyword: "haut-parleur iPhone Niort",
    category: "iPhone",
    icon: "Volume2",
    priceFrom: 55,
    priceTo: 95,
    durationMinutes: 45,
    durationLabel: "30-45 minutes",
    symptoms: [
      "Pas de son lors des appels (interlocuteur n'entend pas)",
      "Son très faible ou saturé",
      "Crachotements / parasites",
      "Mode haut-parleur HS mais écouteur OK",
      "Speaker oreille HS mais haut-parleur principal OK",
      "Vidéos sans son",
    ],
    causes: [
      "Poussières / peluches dans la grille",
      "Dégât liquide passé",
      "Chute ayant déconnecté la nappe",
      "Vieillissement (4-5 ans)",
      "Court-circuit",
    ],
    solution: "Test des deux haut-parleurs (oreille + principal), diagnostic du circuit audio. Si encrassement : nettoyage profond gratuit. Si défaillant : démontage iPhone, déconnexion batterie, remplacement du haut-parleur (ear speaker ou loudspeaker selon problème), test appels + multimédia.",
    urgentTip: "💡 Test rapide gratuit : faites un appel et activez le haut-parleur. Si seul le haut-parleur oreille (en haut) est HS, c'est l'ear speaker. Si seul le principal (bas) est HS, c'est le loudspeaker. Mediastore Niort répare les deux séparément.",
    pricing: [
      { model: "Haut-parleur oreille iPhone (ear speaker)", price: "55 €" },
      { model: "Haut-parleur principal iPhone (loudspeaker)", price: "69 €" },
      { model: "Les deux + nappe audio", price: "95 €" },
      { model: "Microphone iPhone", price: "À partir de 59 €" },
    ],
    faqs: [
      { q: "Mon interlocuteur ne m'entend plus, est-ce le micro ou le haut-parleur ?", a: "C'est le MICROPHONE qui est défaillant (pas le haut-parleur — vous l'entendez bien). Mediastore Niort remplace le micro à partir de 59 €. Avant intervention, testez en envoyant un mémo vocal pour confirmer." },
      { q: "Mon iPhone fait des grésillements lors d'appels, c'est grave ?", a: "Non, généralement c'est juste le haut-parleur usé ou encrassé. Remplacement à 54-69 € selon modèle. Mediastore Niort fait un test propre avant intervention pour confirmer." },
      { q: "Pas de son sur YouTube mais audio appel OK, que faire ?", a: "Le haut-parleur principal (loudspeaker) est défaillant. Vérifiez d'abord que le mode silencieux n'est pas activé et que le volume est au max. Si confirmé : remplacement haut-parleur principal à 69 € chez Mediastore Niort." },
    ],
  },
  {
    slug: "vitre-arriere-iphone-niort",
    titleH1: "Remplacement Vitre Arrière iPhone à Niort",
    metaTitle: "Vitre Arrière iPhone Cassée Niort - Réparation Dos en Verre dès 95 €",
    keyword: "vitre arrière iPhone Niort",
    category: "iPhone",
    icon: "Smartphone",
    priceFrom: 95,
    priceTo: 239,
    durationMinutes: 120,
    durationLabel: "2-3 heures",
    symptoms: [
      "Dos en verre fissuré ou éclaté",
      "Vitre arrière qui se décolle",
      "MagSafe qui ne fonctionne plus (verre cassé bloque l'aimant)",
      "Charge sans fil intermittente",
      "Éclats de verre coupants",
    ],
    causes: [
      "Chute sur le dos",
      "iPhone sans coque",
      "Pression dans poche/sac",
    ],
    solution: "Démontage complet de l'iPhone (procédure complexe sur iPhone 8+), retrait du verre arrière au laser (sécurité), nettoyage des résidus, pose du nouveau verre (origine ou compatible premium), recollage avec adhésif aéronautique, contrôle étanchéité.",
    urgentTip: "💡 ATTENTION : la vitre arrière protège la charge sans fil (MagSafe + Qi). Si elle est cassée, la charge filaire fonctionne mais la sans-fil peut être instable. Si MagSafe = important pour vous, faites réparer rapidement.",
    pricing: [
      { model: "Vitre arrière iPhone 15 Pro Max", price: "239 €" },
      { model: "Vitre arrière iPhone 15 / 14 Pro", price: "205 €" },
      { model: "Vitre arrière iPhone 13 / 14", price: "169 €" },
      { model: "Vitre arrière iPhone 12 / 12 Pro / mini", price: "145 €" },
      { model: "Vitre arrière iPhone 11 / XR / XS / X", price: "119 €" },
      { model: "Vitre arrière iPhone 8 / 8 Plus", price: "95 €" },
    ],
    faqs: [
      { q: "Peut-on utiliser un iPhone avec la vitre arrière cassée ?", a: "Oui, mais avec précautions. Les éclats de verre peuvent blesser. De plus, l'absence de protection peut endommager les composants internes (caméra, MagSafe). Mediastore Niort recommande de la remplacer sous 2 semaines max." },
      { q: "Pourquoi la vitre arrière coûte aussi cher que l'écran sur iPhone récents ?", a: "Apple a soudé la vitre arrière au châssis (à partir d'iPhone 8). Son remplacement nécessite un démontage complet, un retrait laser pour éviter d'endommager les composants internes, et un recollage précis. C'est 2-3 fois plus long qu'un changement d'écran. Mediastore Niort maîtrise cette procédure (Apple-certifié)." },
      { q: "Existe-t-il une alternative moins chère que le remplacement vitre arrière ?", a: "Oui : une coque opaque qui couvre la fissure (5-29 €). C'est une solution provisoire qui évite les blessures mais ne restaure pas MagSafe ni la charge sans-fil. Pour un usage long terme, le remplacement reste recommandé." },
    ],
  },
  {
    slug: "ecran-mac-niort",
    titleH1: "Réparation Écran MacBook à Niort - Apple Certifié",
    metaTitle: "Écran MacBook Cassé Niort - Remplacement LCD/Retina dès 359 €",
    keyword: "écran MacBook Niort",
    category: "Mac",
    icon: "Laptop",
    priceFrom: 359,
    priceTo: 899,
    durationMinutes: 240,
    durationLabel: "2 à 4 heures",
    symptoms: [
      "Écran fissuré ou cassé",
      "Lignes verticales / horizontales",
      "Pixels morts visibles",
      "Affichage strié ou bleuté",
      "Écran qui clignote",
      "Backlight (rétro-éclairage) HS",
      "Charnière cassée qui maintient l'écran",
    ],
    causes: [
      "Chute du MacBook (clé tombée entre écran et clavier)",
      "Stylo / câble écrasé en fermant le capot",
      "Pression sur l'écran (sac trop chargé)",
      "Choc thermique",
      "Câble flex écran défaillant",
    ],
    solution: "Diagnostic complet (écran, GPU, câble flex, carte mère). Démontage du capot MacBook, déconnexion batterie obligatoire, remplacement de l'assemblage écran complet (LCD/Retina + boîtier + charnière), recalibrage True Tone si applicable, test affichage en conditions diverses. Main d'œuvre : 79 €/h.",
    urgentTip: "💡 Ne forcez PAS sur l'écran s'il est partiellement cassé. Une fissure peut s'agrandir et endommager le câble flex (plus cher à réparer). Apportez-le en l'état à Mediastore Niort pour diagnostic gratuit.",
    pricing: [
      { model: "MacBook Air M3/M2/M1 13\"", price: "359 €" },
      { model: "MacBook Pro 13\" (M1/M2)", price: "479 €" },
      { model: "MacBook Pro 14\" (M1 Pro/Max+)", price: "599 €" },
      { model: "MacBook Pro 15\"/16\" (Intel)", price: "599 €" },
      { model: "MacBook Pro 16\" (M1 Pro/Max/M3+)", price: "899 €" },
      { model: "MacBook Air/Pro - changement câble flex seul", price: "À partir de 179 €" },
    ],
    faqs: [
      { q: "Est-ce moins cher de réparer l'écran MacBook chez Apple ou chez Mediastore Niort ?", a: "Généralement 30 à 50% moins cher chez Mediastore Niort. Apple facture en moyenne 700-1199 € pour un écran MacBook (forfait). Nous proposons 359-899 € selon modèle avec garantie 6 mois et techniciens Apple certifiés. Main d'œuvre 79 €/h transparente." },
      { q: "Peut-on remplacer uniquement le verre de l'écran MacBook sans tout changer ?", a: "Sur MacBook Pro Retina (Intel) jusqu'en 2018 : OUI, remplacement du verre seul possible (~ 179 €). Sur MacBook Air M1/M2/M3 et MacBook Pro M1+ : NON, l'écran est un assemblage soudé, remplacement complet uniquement. Diagnostic gratuit chez Mediastore Niort." },
      { q: "Combien de temps prend une réparation d'écran MacBook chez Mediastore Niort ?", a: "Sur place : 2 à 4 heures (modèles courants stock). Pour modèles plus rares (MacBook Pro 16\" M3 Max etc.) : pièce commandée sous 48-72h. Possibilité de Click & Collect avec retour Colissimo gratuit > 49 €." },
    ],
  },
  {
    slug: "batterie-macbook-niort",
    titleH1: "Changement Batterie MacBook à Niort - Apple Certifié",
    metaTitle: "Batterie MacBook usée Niort - Remplacement MacBook Air/Pro dès 155 €",
    keyword: "batterie MacBook Niort",
    category: "Mac",
    icon: "Battery",
    priceFrom: 155,
    priceTo: 299,
    durationMinutes: 120,
    durationLabel: "1-2 heures",
    symptoms: [
      "Autonomie qui chute drastiquement (8h → 2h)",
      "MacBook qui s'éteint à 30-50% de batterie",
      "Message 'Service Recommended' dans Réglages",
      "Capacité maximale < 80% (Pomme > À propos > Plus d'infos > Système)",
      "MacBook qui gonfle (DANGER, écran qui se décolle, touches déformées)",
      "Très chaud lors de charge",
    ],
    causes: [
      "Vieillissement (1000+ cycles sur MacBook)",
      "Charge nocturne prolongée pendant des années",
      "Utilisation intensive (vidéo, gaming)",
      "Exposition à températures extrêmes",
      "Charge avec chargeur non-officiel sous-puissance",
    ],
    solution: "Diagnostic santé batterie (Coconut Battery / outil pro Apple), démontage du fond du MacBook, déconnexion sécurisée, retrait des cellules (gestion adhésif au solvant), pose batterie neuve haute capacité, recalibrage initial. Main d'œuvre : 79 €/h.",
    urgentTip: "🚨 SI VOTRE MACBOOK GONFLE (écran qui se décolle, touches qui se soulèvent, dos bombé) : ÉTEIGNEZ-LE IMMÉDIATEMENT et apportez-le à Mediastore Niort sans le rallumer. Risque d'incendie élevé. La batterie au lithium peut prendre feu spontanément.",
    pricing: [
      { model: "Batterie MacBook Air M3/M2/M1 13\"", price: "155 €" },
      { model: "Batterie MacBook Air Intel 13\" (2018-2020)", price: "155 €" },
      { model: "Batterie MacBook Pro 13\" (M1/M2 et Intel)", price: "179 €" },
      { model: "Batterie MacBook Pro 14\" (M1 Pro/Max, M3 Pro/Max)", price: "239 €" },
      { model: "Batterie MacBook Pro 15\"/16\" Intel", price: "239 €" },
      { model: "Batterie MacBook Pro 16\" (M1 Pro/Max, M3 Pro/Max)", price: "299 €" },
    ],
    faqs: [
      { q: "Comment vérifier la santé de la batterie de mon MacBook ?", a: "Cliquez sur la 🍎 Pomme > À propos de ce Mac > Plus d'infos > Système > Énergie. Vous voyez 'Nombre de cycles' et 'État de la batterie'. Si l'état est 'Service Recommandé' OU si les cycles > 1000 (Mac récents) OU 500 (Mac anciens), remplacement recommandé. Mediastore Niort propose un diagnostic plus précis gratuitement." },
      { q: "Combien de cycles a une batterie MacBook ?", a: "Apple garantit 1000 cycles avec 80% de capacité initiale sur MacBook Air/Pro récents (à partir de 2009). En usage quotidien (1 cycle ≈ 1 jour intensif), cela représente ~3-5 ans de vie. Mediastore utilise des batteries garanties 1000 cycles minimum." },
      { q: "Mediastore peut-il remplacer ma batterie MacBook le jour-même ?", a: "Pour les modèles courants (MacBook Air M1/M2/M3, MacBook Pro M1/M2/M3 13\") : OUI sur RDV, intervention 1-2h en boutique. Pour les modèles plus rares (16\" Pro Max, anciens Intel) : commande sous 48-72h. Click & Collect avec expédition Colissimo gratuit > 49 € disponible." },
    ],
  },
  {
    slug: "ps5-hdmi-niort",
    titleH1: "Réparation PS5 HDMI Cassé à Niort - PlayStation 5",
    metaTitle: "PS5 HDMI Cassé Niort - Réparation Sortie HDMI PlayStation 5 dès 119 €",
    keyword: "PS5 HDMI Niort",
    category: "Console",
    icon: "Gamepad2",
    priceFrom: 119,
    priceTo: 179,
    durationMinutes: 4320,
    durationLabel: "3-5 jours",
    symptoms: [
      "Aucun signal sur TV (écran noir)",
      "Image qui clignote ou disparaît",
      "Port HDMI visiblement enfoncé ou cassé",
      "Console détecte la TV mais aucun affichage",
      "Câble HDMI qui doit être maintenu",
      "Broches HDMI tordues",
    ],
    causes: [
      "Câble HDMI tiré violemment",
      "Chute de la PS5 avec câble branché",
      "Enfants qui ont arraché le câble",
      "Mauvaise manipulation",
      "Court-circuit interne (rare)",
    ],
    solution: "Diagnostic complet : test signal HDMI, port physique, puce APU. Si port HDMI cassé physiquement : dessoudage de l'ancien port (procédure microsoudure professionnelle), nettoyage des pastilles, soudage du nouveau port HDMI ALPS officiel, test signal 4K HDR, contrôle thermique.",
    urgentTip: "⚠️ NE PAS forcer un câble HDMI dans un port endommagé : vous risquez d'endommager la carte mère (plusieurs centaines d'euros de réparation supplémentaire). Apportez votre PS5 telle quelle à Mediastore Niort.",
    pricing: [
      { model: "Remplacement port HDMI PS5 standard", price: "119 €" },
      { model: "Remplacement port HDMI PS5 Slim", price: "145 €" },
      { model: "Remplacement port HDMI PS5 Pro", price: "169 €" },
      { model: "Réparation puce HDMI (si carte mère endommagée)", price: "179 €" },
      { model: "Nettoyage interne + pâte thermique offert", price: "Inclus" },
    ],
    faqs: [
      { q: "Combien de temps pour réparer une PS5 chez Mediastore Niort ?", a: "Délai typique 3 à 5 jours ouvrés (pièce commandée + intervention micro-soudure spécialisée). Pour les vacances scolaires, possibilité de réparation accélérée (sur disponibilité). Diagnostic gratuit sous 24h." },
      { q: "Sony Apple peut-il réparer mon HDMI PS5 sous garantie ?", a: "Si votre PS5 est sous garantie (2 ans après achat avec facture), Sony peut intervenir GRATUITEMENT — c'est l'option à privilégier d'abord. Mais le délai Sony est de 3-4 semaines minimum. Mediastore Niort intervient en 3-5 jours, idéal hors garantie ou si Sony refuse (chute = exclusion garantie)." },
      { q: "Mediastore garantit-il la réparation HDMI PS5 ?", a: "Oui, 6 mois garantie complète (pièce + main d'œuvre). En cas de récidive (rare, < 2%), nous reprenons à 100%. Diagnostic gratuit + devis ferme avant intervention." },
    ],
  },
  {
    slug: "recuperation-donnees-niort",
    titleH1: "Récupération de Données à Niort - PC, Mac, Smartphone, Disque Dur",
    metaTitle: "Récupération Données Niort - Disque Dur Mort, Mac, iPhone dès 95 €",
    keyword: "récupération données Niort",
    category: "Informatique",
    icon: "HardDrive",
    priceFrom: 95,
    priceTo: 599,
    durationMinutes: 4320,
    durationLabel: "1 à 5 jours",
    symptoms: [
      "Disque dur qui ne s'affiche plus",
      "Bruit de cliquetis (disque dur défaillant)",
      "Message 'Disque non formaté' ou 'corrompu'",
      "PC/Mac qui ne démarre plus",
      "SSD soudain illisible",
      "Suppression accidentelle de fichiers",
      "Formatage par erreur",
      "Crash après mise à jour",
      "Ransomware (chiffrement malveillant)",
    ],
    causes: [
      "Usure naturelle (HDD : 4-7 ans, SSD : 5-10 ans)",
      "Chute du PC portable",
      "Coupure de courant brutale",
      "Virus / ransomware",
      "Erreur humaine (suppression, formatage)",
      "Crash logiciel",
    ],
    solution: "Diagnostic gratuit du support (HDD, SSD, NAND iPhone/Android, clé USB, carte SD). Selon l'état : (1) récupération logicielle (cas simples, 95-179 €), (2) récupération par imagerie (clone et extraction, 179-359 €), (3) salle blanche pour HDD avec dommage physique tête/plateaux (sur devis, 359-599 €). Taux de succès moyen : 85%.",
    urgentTip: "🚨 NE PAS continuer à utiliser un disque dur défaillant : chaque écriture supplémentaire écrase potentiellement les données. ÉTEIGNEZ et débranchez immédiatement. NE PAS tenter de réparer soi-même (logiciels gratuits aggravent souvent les dégâts).",
    pricing: [
      { model: "Récupération logicielle SSD/HDD sain (suppression accidentelle)", price: "95 €" },
      { model: "Récupération SSD/HDD avec secteurs défectueux", price: "179 €" },
      { model: "Récupération iPhone (depuis sauvegarde ou direct)", price: "145 €" },
      { model: "Récupération Mac (Fusion Drive, Time Machine corrompue)", price: "205 €" },
      { model: "Récupération HDD avec bruit mécanique (salle blanche)", price: "À partir de 359 €" },
      { model: "Décryptage ransomware (si clé disponible)", price: "Sur devis" },
      { model: "Carte SD / clé USB", price: "À partir de 95 €" },
    ],
    faqs: [
      { q: "Mes données sont-elles confidentielles chez Mediastore Niort ?", a: "Oui, totalement. Mediastore Niort suit une politique de confidentialité stricte : aucune consultation des fichiers personnels au-delà du nécessaire technique, suppression sécurisée de toute copie après livraison, accord de confidentialité signé sur demande. Atelier sécurisé." },
      { q: "Quel est le taux de récupération de données chez Mediastore Niort ?", a: "85% en moyenne sur l'ensemble des cas. 95% sur SSD logiciel et 70-80% sur HDD avec panne mécanique (selon état). Diagnostic gratuit avant devis, vous ne payez QUE si nous récupérons effectivement vos données." },
      { q: "Peut-on récupérer les photos d'un iPhone tombé dans l'eau et qui ne s'allume plus ?", a: "Oui dans la majorité des cas. Mediastore Niort peut soit : (1) réparer temporairement l'iPhone pour sauvegarder, (2) extraire directement la NAND si la carte mère est endommagée (compétence spécialisée). Tarif iPhone : à partir de 145 €. Diagnostic gratuit." },
      { q: "Quel délai pour une récupération de données ?", a: "Cas simples (logiciel SSD) : 24-48h. Cas moyens (HDD secteurs défectueux) : 3-5 jours. Cas complexes (salle blanche, tête HDD remplacée) : 5-15 jours selon disponibilité pièce. Devis et délai précis sous 24h après diagnostic." },
    ],
  },
];

export const findPanneBySlug = (slug) => PANNES.find((p) => p.slug === slug);
